import React, {Component} from 'react'
import PropTypes from 'prop-types'
import MillenialsItem from "./milenials-item";
import {connect} from "react-redux";
import ComponentHOC from "../hoc/ComponentHOC";
import Post from "../models/posts";

class MillenialsComponent extends Component {
    render(){
        const {title, list, size, screenWidth, roles} = this.props
        return (
            <section className="millenials-section">
                <div className="container">
                    {window.location.pathname !== "/"?<h2>{title}</h2>:''}
                    <div className="row justify-content-center millenials-list">
                        <div className={'col-12 col-lg-'+size+' millenials-chart'}>
                            {list.map( (item, index) => {
                                var obj = new Post(item)
                                if(screenWidth < 992 && roles)
                                    if(index > roles)
                                        return
                                return <MillenialsItem key={index} item={obj}/>
                            })}
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

MillenialsComponent.propType = {
    title: PropTypes.string.isRequired,
    list: PropTypes.array.isRequired,
    size: PropTypes.number.isRequired
}



export default connect(state => state)(ComponentHOC(MillenialsComponent))


// WEBPACK FOOTER //
// ./src/components/millenials.js